<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <el-radio-group v-model="type" size="mini" @change="changeList" :disabled="loading">
        <el-radio-button :label="0">审核中</el-radio-button>
        <el-radio-button :label="1">已通过</el-radio-button>
        <el-radio-button :label="2">已拒绝</el-radio-button>
      </el-radio-group>
    </base-header>
    <el-main>
      <el-table :data="joinList" height="100%" v-loading="loading">
        <el-table-column label="微信头像和昵称" width="140">
          <template v-slot="scope">
            <div style="display: flex; align-items: center;">
              <img v-if="scope.row.avatar_url" :src=scope.row.avatar_url style="width: 30px; height: 30px;">
              {{scope.row.nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableColumn"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          align="center">
        </el-table-column>
        <el-table-column label="查看商品" align="center">
          <template v-slot="scope">
            <el-popover
              title="小程序码"
              trigger="click">
              <img :src="scope.row.qrcode_url" style="width: 150px; height: 150px;">
              <span slot="reference">查看</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="申请结果" align="center">
          <template v-slot="scope">
            <div v-if="!type && !scope.row.refused">
              <span style="color: red; margin-right: 20px;" @click="processingJoin(0, scope.row)">拒绝</span>
              <span @click="processingJoin(1, scope.row)">编辑</span>
            </div>
            <div v-else>
              <div v-if="type === 2 || scope.row.refused">已拒绝</div>
              <div v-else>已通过</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import pageMixin from '../../../../mixins/page'

export default {
  name: 'GoodJoin',
  mixins: [pageMixin],
  data () {
    return {
      joinList: [],
      joinPlatformListUrl: this.getDomain() + 'bmgoods/join_platform_list',
      processingJoinUrl: this.getDomain() + 'bmgoods/processing_join',
      loading: false,
      tableColumn: [
        {
          prop: 'client_id',
          label: 'userID',
          width: 80
        }, {
          prop: 'phone',
          label: '电话号码'
        }, {
          prop: 'apply_time',
          label: '申请时间'
        }, {
          prop: 'goods_name',
          label: '商品名称'
        },
        {
          prop: 'cost_price',
          label: '供货价'
        }
      ],
      type: 0
    }
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        type: this.type
      }
      let handle = res => {
        this.totalCount = res.data.content.total_count
        this.joinList = res.data.content.join_list
        this.joinList.forEach(item => {
          item.cost_price = item.cost_price / 100
          item.apply_time = this.timeTransform(item.apply_time)
          this.$set(item, 'refused', false)
        })
      }
      let loadings = () => {
        this.loading = false
      }
      this.__axios(this.joinPlatformListUrl, params, handle, loadings)
    },
    changeList () {
      this.loading = true
      this.page = 1
      this.pagesize = 50
      this.getList()
    },
    processingJoin (type, row) {
      let params = {
        type: type,
        join_platform_id: row.join_platform_id
      }
      let handle = () => {
        row.refused = true
      }
      if (!type) {
        this.__confirm('确认拒绝？', this.__axios, [this.processingJoinUrl, params, handle])
      } else {
        this.$router.push({
          name: 'GoodsEdit',
          query: {
            join_platform_id: row.join_platform_id
          }
        })
      }
    }
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped>
  span {
    color: #3a8ee6;
    cursor: pointer;
  }
</style>
